interface ExternalLinkIconProps {
  className?: string;
}

export function ExternalLinkIcon({ className = '' }: ExternalLinkIconProps) {
  return (
    <svg
      viewBox="0 0 800 800"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      className={`inline-block w-4 h-4 md:w-[18px] md:h-[18px] ${className}`}
    >
      <path
        d="M664.875 145.65L664.85 145.325L664.8 145.275C663.4 142.25 661.325 139.75 658.725 137.875L658.675 137.825C658.125 137.4 657.525 136.975 656.875 136.6L656.8 136.55C654.175 134.85 650.975 133.825 647.525 133.725H293.925C283.575 133.725 275.175 142.125 275.175 152.475C275.175 162.825 283.575 171.225 293.925 171.225H602.225L139.225 634.2C135.825 637.6 133.725 642.3 133.725 647.475C133.725 657.85 142.125 666.25 152.5 666.25C157.675 666.25 162.35 664.15 165.75 660.775L628.75 197.775V506.025C628.75 516.375 637.15 524.775 647.5 524.775C657.85 524.775 666.25 516.375 666.25 506.025V152.475C666.225 150 665.725 147.65 664.825 145.5L664.875 145.625V145.65Z"
        fill="currentColor"
      />
    </svg>
  );
}
